/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const WifiOffGenericIcon: FC<AllieIconProps> = ({ allieColor = 'neutral-60' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="239" height="239" viewBox="0 0 239 239" fill="none">
    <path
      d="M152.481 99.5835C166.107 103.829 178.875 110.728 190.005 119.998M224.858 84.6456C195.756 58.9926 158.294 44.8386 119.499 44.8386C113.474 44.8386 107.482 45.18 101.547 45.8528M84.9424 155.45C95.0522 148.267 107.146 144.409 119.548 144.409C131.949 144.409 144.043 148.267 154.153 155.45M119.5 194.187H119.6M11.8839 86.6451C25.1644 74.4753 40.5144 64.5275 57.3451 57.3905M47.1222 121.92C61.038 109.661 78.0905 100.879 96.9209 96.9337M156.329 157.094C146.181 149.139 133.394 144.396 119.499 144.396C105.394 144.396 92.4305 149.283 82.2097 157.457M29.875 29.875L209.125 209.125"
      stroke={`var(--allie-color-${allieColor})`}
      strokeWidth="19.9167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
